import {Component, Inject, OnInit} from '@angular/core';
import {TypeSelectChipsDialog} from "../../../providers/service/open-dialog.service";
import {arrayIsSet, isNotNullOrUndefined, stringIsSet} from "../../../providers/service/global-variables.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-select-with-chips',
    templateUrl: './select-with-chips.component.html',
    styleUrls: ['./select-with-chips.component.scss'],
    standalone: false
})
export class SelectWithChipsComponent implements OnInit {

    public isSetSlideValue = false;
    public isSetChips = false;
    public chipsSizeClass: string = '';

    public selectedChips: TypeSelectChipsDialog[] = [];
    private indexSlideValues = 0;

    constructor(public dialogRef: MatDialogRef<SelectWithChipsComponent>,
                @Inject(MAT_DIALOG_DATA) public data: { slideValues: TypeSelectChipsDialog[], chips: TypeSelectChipsDialog[], multipleValue: boolean, chipsDisabled: any, css: { chipsClass: { size: string } }, initialSlideId?: string, initialChipIds?: string[] }) {
    }

    ngOnInit(): void {
        this.isSetSlideValue = arrayIsSet(this.data.slideValues)
        if (this.isSetSlideValue) {
            const initialIndex = this.data.slideValues.findIndex(slide => slide.id === this.data.initialSlideId)
            this.indexSlideValues = initialIndex >= 0 ? initialIndex : this.data.slideValues.length - 1
        }
        this.isSetChips = arrayIsSet(this.data.chips)
        if (this.isSetChips && arrayIsSet(this.data.initialChipIds)) {
            this.selectedChips = this.data.chips.filter(chip => this.data.initialChipIds!.includes(chip.id))
        }
        if (isNotNullOrUndefined(this.data.css) && isNotNullOrUndefined(this.data.css.chipsClass) && stringIsSet(this.data.css.chipsClass.size)) {
            this.chipsSizeClass = this.data.css.chipsClass.size;
        } else {
            this.chipsSizeClass = 'chips-size-M';

        }
    }

    disabledChips(chip: TypeSelectChipsDialog): boolean {
        if (this.data.chipsDisabled) {
            return this.data.chipsDisabled(chip, this.data.slideValues[this.indexSlideValues])
        } else {
            return false
        }
    }

    chipsIsSelected(chip: TypeSelectChipsDialog): boolean {
        const index = this.selectedChips.findIndex(chipSelected => chip.id === chipSelected.id)
        return index >= 0
    }

    clickChips(chip: TypeSelectChipsDialog) {
        const isDisabled = this.disabledChips(chip)
        if (!isDisabled) {
            const index = this.selectedChips.findIndex(chipSelected => chip.id === chipSelected.id)
            if (index >= 0) {
                this.selectedChips.splice(index, 1)
            } else if (this.data.multipleValue) {
                this.selectedChips.push(chip)
            } else {
                this.selectedChips = [chip]
            }
        }
    }

    cssChips(chip: TypeSelectChipsDialog): string {
        if (this.disabledChips(chip)) {
            return 'huna-disabled'
        } else if (this.chipsIsSelected(chip)) {
            return 'huna-select'
        } else {
            return 'huna-not-select'
        }
    }

    get traductionSlidesValue(): string {
        return this.data.slideValues[this.indexSlideValues].traductionKey
    }

    slideNext() {
        this.indexSlideValues = (this.indexSlideValues + 1) % this.data.slideValues.length
    }

    slideBefore() {
        this.indexSlideValues = (this.indexSlideValues - 1) < 0 ? this.data.slideValues.length - 1 : this.indexSlideValues - 1;
    }

    emitValue(emitValue: boolean) {
        if (emitValue) {
            this.dialogRef.close({
                selectedChips: this.selectedChips,
                slidesValue: this.data.slideValues[this.indexSlideValues]
            })
        } else {
            this.dialogRef.close()
        }
    }

    get disableCheckButton() {
        return this.isSetChips && !arrayIsSet(this.selectedChips)
    }

}
